import PropTypes from "prop-types";
import React from "react";
import { Toggle } from "@opendate-app/setlist";

const TixelWaitlistRedirectToggle = ({ id, checked, onChange }) => (
  <Toggle
    id={id}
    label={checked ? "Redirect to Tixel Enabled" : "Redirect to Tixel Disabled"}
    checked={Boolean(checked)}
    onChange={(e) => onChange(e.target.checked)}
  />
);

TixelWaitlistRedirectToggle.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default TixelWaitlistRedirectToggle;
